import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';

@Component({
  standalone: true,
  imports: [MatLegacyButtonModule],
  selector: 'app-custom-back-button',
  templateUrl: './custom-back-button.component.html',
})
export class CustomBackButtonComponent {
  private router: Router = inject(Router);
  private location: Location = inject(Location);

  @Input() public customUrl: string | undefined;

  public back(): void {
    if (this.customUrl) {
      this.router.navigateByUrl(this.customUrl);
    } else {
      this.location.back();
    }
  }
}
